import { createComponent } from "./auth-service-tools631.js";
import { createHook } from "./auth-service-tools637.js";
import "react";
import { useTabbable } from "./auth-service-tools650.js";
var INPUT_KEYS = [];
var useInput = createHook({
  name: "Input",
  compose: useTabbable,
  keys: INPUT_KEYS
});
var Input = createComponent({
  as: "input",
  memo: true,
  useHook: useInput
});
export { Input, useInput };